import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _valuesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/values';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import clsx from 'clsx';
import React, { useEffect, useCallback } from 'react';
import { useTUXCheckboxContext } from './TUXCheckbox.context.js';
import { SquareBorder, CircleBorder, SquareSolid, CircleSolid, SquareTick, CircleTick } from './TUXCheckboxIcon.js';
import { useControlled } from '../../hooks/useControlled.js';

var CheckboxIcon = function CheckboxIcon(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      color = _ref.color,
      variant = _ref.variant,
      size = _ref.size;
  var iconSize = size === 'small' ? 16 : 24;
  var globalOpacity = disabled ? 0.34 : 1;
  var uncheckedOpacity = checked ? 0 : 1;
  var checkedOpacity = checked ? 1 : 0;
  var Border = variant === 'square' ? SquareBorder : CircleBorder;
  var Solid = variant === 'square' ? SquareSolid : CircleSolid;
  var Tick = variant === 'square' ? SquareTick : CircleTick;
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: iconSize,
    height: iconSize,
    opacity: globalOpacity,
    className: "TUXCheckbox__icon"
  }, /*#__PURE__*/React.createElement(Border, {
    className: color === 'const' ? 'text-color-ConstTextInverse' : 'text-color-LineSecondary',
    stroke: "currentColor",
    strokeWidth: "1.5",
    opacity: uncheckedOpacity
  }), /*#__PURE__*/React.createElement(Solid, {
    className: "text-color-Primary",
    fill: "currentColor",
    opacity: checkedOpacity
  }), /*#__PURE__*/React.createElement(Tick, {
    className: "text-color-ConstTextInverse",
    fill: "currentColor",
    opacity: checkedOpacity
  }));
};

var TUXCheckbox = function TUXCheckbox(_ref2) {
  var _ref2$defaultChecked = _ref2.defaultChecked,
      defaultChecked = _ref2$defaultChecked === void 0 ? false : _ref2$defaultChecked,
      checked = _ref2.checked,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'circle' : _ref2$variant,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'default' : _ref2$color,
      disabled = _ref2.disabled,
      name = _ref2.name,
      value = _ref2.value,
      onChange = _ref2.onChange;

  var _useControlled = useControlled({
    value: checked,
    defaultValue: defaultChecked
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      internalChecked = _useControlled2[0],
      setInternalChecked = _useControlled2[1];

  var _useTUXCheckboxContex = useTUXCheckboxContext(),
      inGroup = _useTUXCheckboxContex.inGroup,
      disabledAll = _useTUXCheckboxContex.disabledAll,
      updateState = _useTUXCheckboxContex.updateState,
      values = _valuesInstanceProperty(_useTUXCheckboxContex);

  var isDisabled = disabled || disabledAll;

  useEffect(function () {
    if (inGroup) {
      var next = _indexOfInstanceProperty(values).call(values, value) > -1;

      if (next === internalChecked) {
        return;
      }

      setInternalChecked(next);
    }
  }, [inGroup, internalChecked, setInternalChecked, value, values]);
  var changeHandler = useCallback(function (e) {
    if (isDisabled) {
      return;
    }

    if (inGroup && updateState) {
      updateState(value, e.target.checked);
    }

    setInternalChecked(e.target.checked);
    onChange && onChange(e);
  }, [inGroup, isDisabled, onChange, setInternalChecked, updateState, value]);
  return /*#__PURE__*/React.createElement("label", {
    className: clsx('inline-block box-border', {
      'medium': 'w-24 h-24',
      'small': 'w-16 h-16'
    }[size])
  }, /*#__PURE__*/React.createElement("input", {
    className: "hidden",
    name: name,
    type: "checkbox",
    value: value,
    checked: internalChecked,
    disabled: isDisabled,
    onChange: changeHandler
  }), /*#__PURE__*/React.createElement(CheckboxIcon, {
    checked: internalChecked,
    color: color,
    variant: variant,
    disabled: isDisabled,
    size: size
  }));
};

export { TUXCheckbox };
//# sourceMappingURL=TUXCheckbox.js.map
